import f, { css as o } from "styled-components";
import { FONT as e } from "../../constants/font.es.js";
const m = {
  primary: e.primary,
  secondary: e.secondary
}, u = f.p.withConfig({
  displayName: "Typography",
  componentId: "sc-aew5s3-0"
})(["", ""], ({
  theme: r,
  variant: n,
  color: p,
  emphasis: s,
  lineClamp: t,
  fontFamily: i,
  underline: c,
  lineThrough: y,
  uppercase: d,
  hoverUnderline: l
}) => {
  var a;
  return o(["", " color:var(--color-", "-", ");margin:0;", " ", " ", " ", " ", " ", ""], (a = r == null ? void 0 : r.typography) == null ? void 0 : a[n], p, s, i && o(["font-family:", ";"], m[i]), t && o(["-webkit-box-orient:vertical;-webkit-line-clamp:", ";display:-webkit-box;overflow:hidden;"], t), c && o(["text-decoration:underline;"]), y && o(["text-decoration:line-through;"]), d && o(["text-transform:uppercase;"]), l && o(["transition:all 0.2s ease-in-out;&:hover{text-decoration:underline;}"]));
});
export {
  u as Typography
};
//# sourceMappingURL=style.es.js.map
